import React from "react";
import classes from "./styles/style.module.css";

export default function QuestionTitle({ imgSrc, title, noBg, noImg, puzzle }) {
  return (
    <div className={classes.questionTitle}>
      {noImg ? null : noBg ? (
        <img
          crossOrigin="anonymous"
          src={imgSrc}
          alt="questionPic"
          className={`${classes.questionImg} ${puzzle ? classes.puzzle : ""}`}
        />
      ) : (
        <div className={classes.qusestionImageContainer}>
          <img src={imgSrc} alt="questionPic" crossOrigin="anonymous" />
        </div>
      )}
      <p>{title}</p>
    </div>
  );
}
